var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 430,
    viewBox: "0 0 433 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.69812 195.507C214.138 198.075 385.453 386.138 432.594 429.84L407.915 0.336842C271.272 108.758 84.3354 195.309 2.69812 195.507C1.86475 195.497 1.03078 195.49 0.196184 195.485C1.01877 195.502 1.85278 195.509 2.69812 195.507Z",
    fill: "url(#paint0_linear_300_90747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25558 195.569C216.519 198.734 361.188 281.845 407.914 325.163L414.637 66.1831C281 172.22 92.9576 195.641 8.25558 195.569C5.5791 195.528 2.89214 195.501 0.194732 195.487C2.76479 195.538 5.45364 195.566 8.25558 195.569Z",
    fill: "url(#paint1_linear_300_90747)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407.914 325.163C360.588 281.289 212.784 196.591 0.194732 195.487C80.4572 197.1 276.579 175.727 414.637 66.1831L407.914 325.163Z",
    stroke: "url(#paint2_linear_300_90747)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_90747",
    x1: 414.53,
    y1: 194.747,
    x2: 0.195705,
    y2: 194.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E2F3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2196F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_90747",
    x1: 414.53,
    y1: 194.747,
    x2: -142.363,
    y2: 195.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFDFF6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DA2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_300_90747",
    x1: 414.529,
    y1: 195.955,
    x2: 0.196087,
    y2: 194.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF1DB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF1DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.c8ee72d4cf38f33f9a9791722b7ff533.svg";
export { ForwardRef as ReactComponent };